import Big from 'big.js';
import Util from 'lib/util';
const isBig = Util.isBig;
const isArray = Array.isArray;

const AssessmentFns = {
  /**
   * 组装报告详情数据，将评分数据组装到树状评分配置项中
   *
   * @param detail: 详情
   * @param isPurchase 是否采购方
   */
  parseReportDetail(detail, isPurchase: boolean = true) {
    let obj = {};
    let prop = isPurchase
      ? 'admissionReportDetailList'
      : 'customerAdmissionReportDetailList';
    //数组转对象，便于匹配
    if (isArray(detail[prop])) {
      detail[prop].forEach(item => {
        let inspectionItemCode = item.inspectionItemCode;
        obj[inspectionItemCode] = item;
      });
    }

    let parseList = (list, inspectionParentItemCode) => {
      if (isArray(list)) {
        list.forEach(item => {
          if (item.itemType === 0) {
            let itemCode = item.itemCode;
            let scoreInfo = obj[itemCode];
            if (scoreInfo) {
              item.inspectionItemCode = scoreInfo.inspectionItemCode;
              item.inspectionParentItemCode =
                scoreInfo.inspectionParentItemCode;
              item.inspectionScore = scoreInfo.inspectionScore;
              item.involveFlag = scoreInfo.involveFlag;
              item.scoreDescription = scoreInfo.scoreDescription;
              item.ownScore = scoreInfo.ownScore;
              item.vdescription = scoreInfo.vdescription;
            } else {
              item.inspectionItemCode = itemCode;
              item.inspectionParentItemCode = inspectionParentItemCode;
              item.involveFlag = 1; //默认不勾选
            }
          } else if (item.itemType === 1 && isArray(item.itemList)) {
            parseList(item.itemList, item.itemCode);
          }
        });
      }
    };

    parseList(detail.inspectionItemList, undefined);

    //描述转化
    if (detail.description) {
      let description = detail.description.replace(
        /\t/g,
        '&nbsp;&nbsp;&nbsp;&nbsp;'
      );
      description = description.replace(/\r\n/g, '<br/>');
      description = description.replace(/\n/g, '<br/>');
      description = description.replace(/\s/g, ' ');
      detail.descriptionShow = description;
    }
  },

  /**
   * 从详情获取评分项，用于保存和校验
   *
   * @param detail
   * @param isPurchase
   * @returns 扁平化后的评分项列表
   */
  getScoreList(detail, isPurchase: boolean = true) {
    let arr: any[] = [];
    let arrField = [
      'inspectionItemCode',
      'inspectionParentItemCode',
      'inspectionScore',
      'scoreDescription',
      'itemScore'
    ];
    if (isPurchase === false) {
      arrField = [
        'inspectionItemCode',
        'inspectionParentItemCode',
        'ownScore',
        'involveFlag',
        'vdescription',
        'itemScore'
      ];
    }
    let parseList = list => {
      if (isArray(list)) {
        list.forEach(item => {
          if (item.itemType === 0) {
            let obj = {};
            arrField.forEach(field => {
              obj[field] = item[field];
            });
            arr.push(obj);
          } else if (item.itemType === 1 && isArray(item.itemList)) {
            parseList(item.itemList);
          }
        });
      }
    };

    parseList(detail.inspectionItemList);

    return arr;
  },

  /**
   * 校验评分，不得大于项目总分
   *
   * @param detail
   * @param isPurchase
   * @returns boolean 是否通过校验
   */
  validateScore(detail, isPurchase: boolean = true) {
    let list = this.getScoreList(detail, isPurchase).filter(
      item => item.involveFlag === 1
    );
    for (let i = 0; i < list.length; i += 1) {
      let item = list[i];
      let score = isPurchase ? item.inspectionScore : item.ownScore;
      if (isBig(score) && Big(score).gt(item.itemScore)) {
        return false;
      }
    }
    return true;
  },

  /**
   * 校验完成度
   *
   * @param detail
   * @returns boolean 是否通过
   */
  validProgress(detail) {
    if (isArray(detail.inspectionItemList)) {
      let list = detail.inspectionItemList;
      for (let i = 0; i < list.length; i += 1) {
        let item = list[i];
        if (item.statisticsInfo.progressRate !== 100) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  },

  /**
   * 计算评分/进度统计信息
   *
   * @param detail
   * @param isPurchase
   */
  getStatisticsInfo(detail, isPurchase: boolean = true) {
    let inspectionItemList;
    inspectionItemList = detail.inspectionItemList;
    if (!isArray(inspectionItemList)) {
      return;
    }

    //总计信息
    let auditResult = {
      maxScore: Big(0),
      validMaxScore: Big(0),
      supplierSelfScore: Big(0),
      selfScoreRate: 100,
      auditScore: Big(0),
      auditScoreRate: 100,
      overallScore: Big(0)
    };

    inspectionItemList.forEach(section => {
      let maxScore = Big(0), //设定总分
        validMaxScore = Big(0), //有效项设定总分
        supplierSelfScore = Big(0), //供应商自评分
        selfScoreCount = 0, //已填自评分计数
        involveFlagCount = 0, //'不涉及'计数
        selfScoreRate = 100, //参考得分|供应商自评分率（%）
        auditScore = Big(0), //评审得分
        auditScoreCount = 0, //评审得分计数
        auditScoreRate = 100, //评审得分率（%）
        progressRate = 100, //填写完成度（%）
        overallScore = 0; //最终得分（含权）

      let arr: any[] = [];
      let parseList = list => {
        if (isArray(list)) {
          list.forEach(item => {
            if (item.itemType === 0) {
              arr.push(item);
            } else if (item.itemType === 1 && isArray(item.itemList)) {
              parseList(item.itemList);
            }
          });
        }
      };
      parseList(section.itemList);

      arr.forEach(item => {
        if (item.itemType === 0) {
          maxScore = maxScore.plus(item.itemScore);
          if (item.involveFlag === 0) {
            //不涉及项
            involveFlagCount += 1;
          } else {
            validMaxScore = validMaxScore.plus(item.itemScore);
            if (isBig(item.ownScore)) {
              supplierSelfScore = supplierSelfScore.plus(item.ownScore);
              selfScoreCount += 1;
            }
            if (isBig(item.inspectionScore)) {
              auditScore = auditScore.plus(item.inspectionScore);
              auditScoreCount += 1;
            }
          }
        }
      });

      if (!validMaxScore.eq(0)) {
        selfScoreRate = supplierSelfScore.div(validMaxScore).times(100);
        auditScoreRate = auditScore.div(validMaxScore).times(100);
      }

      //'不涉及'全部勾选时，视为100%完成
      if (arr.length - involveFlagCount !== 0) {
        let count = isPurchase ? auditScoreCount : selfScoreCount;
        progressRate = Math.round(
          (count / (arr.length - involveFlagCount)) * 100
        );
      }

      overallScore = auditScore.times(section.itemWeight).div(100).toString();
      section.statisticsInfo = {
        maxScore: maxScore.toString(),
        validMaxScore: validMaxScore.toString(),
        supplierSelfScore: supplierSelfScore.toString(),
        involveFlagCount,
        selfScoreRate: Math.round(parseFloat(selfScoreRate.toString())),
        auditScore: auditScore.toString(),
        auditScoreRate: Math.round(parseFloat(auditScoreRate.toString())),
        progressRate,
        overallScore
      };

      //计算总计
      if (isPurchase) {
        auditResult.maxScore = auditResult.maxScore.plus(maxScore);
        auditResult.validMaxScore =
          auditResult.validMaxScore.plus(validMaxScore);
        auditResult.supplierSelfScore =
          auditResult.supplierSelfScore.plus(supplierSelfScore);
        auditResult.auditScore = auditResult.auditScore.plus(auditScore);
        auditResult.overallScore = auditResult.overallScore.plus(overallScore);
      }
    });

    if (isPurchase && !auditResult.validMaxScore.eq(0)) {
      detail.inspectionItemList.statisticsInfo = {
        maxScore: auditResult.maxScore.toString(),
        validMaxScore: auditResult.validMaxScore.toString(),
        selfScoreRate: Math.round(
          parseFloat(
            auditResult.supplierSelfScore
              .div(auditResult.validMaxScore)
              .times(100)
              .toString()
          )
        ),
        auditScore: auditResult.auditScore.toString(),
        auditScoreRate: Math.round(
          parseFloat(
            auditResult.auditScore
              .div(auditResult.validMaxScore)
              .times(100)
              .toString()
          )
        ),
        overallScore: auditResult.overallScore.toString()
      };
    }
  }
};

export default AssessmentFns;
